module.exports = __webpack_public_path__ + "static/media/logo-mineducación.9c989f57.png";